import { AccessibilityText } from '../types'
import { NestedPartial } from '@vista/omnichannel-components-domain'
import {OccAccessibilityText} from '@vista/omnichannel-components-ui'
import {defaultOccAccessibilityText} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/accessibility-text'

export interface getAccessibilityTextDataProps {
    accessibilityText?: NestedPartial<AccessibilityText>
}

export function getAccessibilityTextData(props:getAccessibilityTextDataProps):OccAccessibilityText {
    const {accessibilityText} = props
    return {
        ...defaultOccAccessibilityText,
        filmPosterAltTextFormat: accessibilityText?.filmPosterAltTextFormat || defaultOccAccessibilityText.filmPosterAltTextFormat
    }
}